import React, { Component } from 'react';
import DialogInput from '../advanced/DialogInput';
import Button from './Button';

class ConfirmEmployeeTemplateDialog extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <DialogInput 
                title="Confirm Employee Add"
                actions={[
                    <Button
                        key={1}
                        type="CancelButton"
                        name="buttonCancel"
                        className="btn-space"
                        label="Cancel"
                        onTouchTap={() => this.props.closeDialog()} />,
                    <Button
                        key={3}
                        name="CancelButton"
                        className="mr-1"
                        backgroundColor="Grey"
                        label="CANCEL"
                        primary={true}
                        onTouchTap={() => this.props.closeDialog()} />,
                    <Button
                        key={2}
                        name="ConfirmButton"
                        label="Proceed"
                        primary={true}
                        onTouchTap={() => this.props.createPO()} />]}
                modal={true}
                handleClose={() => this.props.closeDialog()}
                open={this.props.confirmDialog}>
                    <br/>
                    <div>{this.props.branchName ? <p>The branch this Employees is being added to is: <b>{this.props.branchName}</b></p> : ''}
                    {
                                        <p><i>Do not import the same Employee twice,Request will be ignored </i></p>}
                    {this.props.model && this.props.model.Employees && <p><b><br/>There are {this.props.model.Employees.length} Employees in this Request.</b></p>}
                    <br/>
                    <p>Do you want to proceed adding these Employees?</p></div>
            </DialogInput>
        );
    }
}


export default (ConfirmEmployeeTemplateDialog);